if (!customElements.get('ps-media-gallery')) {
  customElements.define(
    'ps-media-gallery',
    class MediaGallery extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        const mainEl = this.querySelector('.ps-psg-main');
        const thumbsEl = this.querySelector('.ps-psg-thumbs');

        if (!mainEl || !thumbsEl) return;

        // Remove hidden slides from wrappers before Swiper counts them
        this.syncVisibleSlides('.ps-psg-main .swiper-wrapper');
        this.syncVisibleSlides('.ps-psg-thumbs .swiper-wrapper');

        // Thumbnail slider - vertical, desktop only
        this.thumbsSwiper = new Swiper(thumbsEl, {
          direction: 'vertical',
          slidesPerView: 4,
          spaceBetween: 0,
          watchSlidesProgress: true,
          navigation: {
            prevEl: this.querySelector('.ps-psg-thumbs-btn--prev'),
            nextEl: this.querySelector('.ps-psg-thumbs-btn--next'),
          },
        });

        // Main slider
        this.mainSwiper = new Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          breakpoints: {
            750: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
          navigation: {
            prevEl: this.querySelector('.ps-psg-nav--prev'),
            nextEl: this.querySelector('.ps-psg-nav--next'),
          },
          pagination: {
            el: this.querySelector('.ps-psg-pagination'),
            type: 'bullets',
            clickable: true,
          },
          thumbs: {
            swiper: this.thumbsSwiper
          },
        });

        // Sync thumb column height to main slider height
        this.syncThumbsHeight();
        this.thumbsResizeObserver = new ResizeObserver(() => this.syncThumbsHeight());
        this.thumbsResizeObserver.observe(mainEl);

        // Re-measure after layout settles (CDN load may run before paint)
        requestAnimationFrame(() => {
          this.mainSwiper.update();
          this.syncThumbsHeight();
          this.thumbsSwiper.update();
        });
      }

      reinit() {
        if (this.thumbsResizeObserver) {
          this.thumbsResizeObserver.disconnect();
          this.thumbsResizeObserver = null;
        }
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
          this.thumbsSwiper = null;
        }

        // Move hidden slides out of each wrapper so Swiper only counts visible ones
        this.syncVisibleSlides('.ps-psg-main .swiper-wrapper');
        this.syncVisibleSlides('.ps-psg-thumbs .swiper-wrapper');
        this.init();
      }

      // Moves hidden slides out of the swiper wrapper so Swiper doesn't count them.
      // On the next call it restores them first, then re-routes based on current visibility.
      syncVisibleSlides(wrapperSelector) {
        const wrapper = this.querySelector(wrapperSelector);
        let holdingArea = wrapper.parentNode.querySelector('.ps-slides-holding-area');
        if (!holdingArea) {
          holdingArea = document.createElement('div');
          holdingArea.className = 'ps-slides-holding-area';
          holdingArea.hidden = true;
          wrapper.parentNode.appendChild(holdingArea);
        }

        const allSlides = [
          ...wrapper.querySelectorAll('.swiper-slide'),
          ...holdingArea.querySelectorAll('.swiper-slide'),
        ];

        allSlides.forEach(slide => {
          if (slide.classList.contains('hide-media')) {
            holdingArea.appendChild(slide);
          } else {
            wrapper.appendChild(slide);
          }
        });
      }

      // set slider thumbnail sidebar height
      syncThumbsHeight() {
        const wrapperEl = this.querySelector('.ps-psg-main .swiper-wrapper');
        const thumbsEl = this.querySelector('.ps-psg-thumbs');
        if (!wrapperEl || !thumbsEl) return;

        const wrapperHeight = wrapperEl.offsetHeight;
        if (wrapperHeight <= 0) return;

        // set thumb height excluding pagination dots
        thumbsEl.style.height = wrapperHeight + 'px';
        this.thumbsSwiper.update();
      }
    }
  );
}
